export default __webpack_public_path__ + "static/owasp-logo-c22359e9779bfb2eaaf865bfb1b5fcd4.png";